import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
import { createDeferred } from '@segment/analytics-generic-utils';
import { pipe } from '../../utils';
import { addBlockingMiddleware } from '../blocking-middleware';
import { createConsentStampingMiddleware } from '../consent-stamping';
import { getPrunedCategories } from '../pruned-categories';
import { validateAnalyticsInstance, validateCategories } from '../validation';
import { logger } from '../logger';
import { parseAllCategories } from '../config-helpers';
import { filterDeviceModeDestinationsForOptIn, segmentShouldBeDisabled } from '../blocking-helpers';
/**
 * This class is a wrapper around the analytics.js library.
 */
export var AnalyticsService = /*#__PURE__*/function () {
  function AnalyticsService(analytics, options) {
    _classCallCheck(this, AnalyticsService);
    this.cdnSettingsDeferred = createDeferred();
    /**
     * Allow for gracefully passing a custom disable function (without clobbering the default behavior)
     */
    this.createDisableOption = function (categories, disable) {
      if (disable === true) {
        return true;
      }
      return function (cdnSettings) {
        return segmentShouldBeDisabled(categories, cdnSettings.consentSettings) || (typeof disable === 'function' ? disable(cdnSettings) : false);
      };
    };
    validateAnalyticsInstance(analytics);
    this.settings = options;
    this.uninitializedAnalytics = analytics;
    this.ogAnalyticsLoad = analytics.load.bind(analytics);
  }
  _createClass(AnalyticsService, [{
    key: "analytics",
    get: function get() {
      return getInitializedAnalytics(this.uninitializedAnalytics);
    }
  }, {
    key: "cdnSettings",
    get: function get() {
      return this.cdnSettingsDeferred.promise;
    }
  }, {
    key: "getAllCategories",
    value: function () {
      var _getAllCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$this$cdnSettin;
        var allCategories;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.settings.integrationCategoryMappings) {
                _context.next = 4;
                break;
              }
              _context.t0 = parseAllCategories(this.settings.integrationCategoryMappings);
              _context.next = 16;
              break;
            case 4:
              _context.next = 6;
              return this.cdnSettings;
            case 6:
              _context.t2 = _yield$this$cdnSettin = _context.sent.consentSettings;
              _context.t1 = _context.t2 === null;
              if (_context.t1) {
                _context.next = 10;
                break;
              }
              _context.t1 = _yield$this$cdnSettin === void 0;
            case 10:
              if (!_context.t1) {
                _context.next = 14;
                break;
              }
              _context.t3 = void 0;
              _context.next = 15;
              break;
            case 14:
              _context.t3 = _yield$this$cdnSettin.allCategories;
            case 15:
              _context.t0 = _context.t3;
            case 16:
              allCategories = _context.t0;
              return _context.abrupt("return", allCategories !== null && allCategories !== void 0 ? allCategories : []);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAllCategories() {
        return _getAllCategories.apply(this, arguments);
      }
      return getAllCategories;
    }()
  }, {
    key: "getCategories",
    value: function () {
      var _getCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var categories;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.settings.getCategories();
            case 2:
              categories = _context2.sent;
              validateCategories(categories);
              return _context2.abrupt("return", categories);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCategories() {
        return _getCategories.apply(this, arguments);
      }
      return getCategories;
    }()
  }, {
    key: "loadWithFilteredDeviceModeDestinations",
    value: function () {
      var _loadWithFilteredDeviceModeDestinations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this,
          _options$updateCDNSet;
        var _len,
          _ref,
          _key,
          settings,
          options,
          initialCategories,
          _filterDeviceModeDestinationsForOptIn,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              for (_len = _args3.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
                _ref[_key] = _args3[_key];
              }
              settings = _ref[0], options = _ref[1];
              _context3.next = 4;
              return this.getCategories();
            case 4:
              initialCategories = _context3.sent;
              _filterDeviceModeDestinationsForOptIn = function _filterDeviceModeDestinationsForOptIn(cdnSettings) {
                return filterDeviceModeDestinationsForOptIn(cdnSettings, initialCategories, {
                  shouldEnableIntegration: _this.settings.shouldEnableIntegration,
                  integrationCategoryMappings: _this.settings.integrationCategoryMappings
                });
              };
              return _context3.abrupt("return", this.load(settings, _objectSpread(_objectSpread({}, options), {}, {
                updateCDNSettings: pipe(_filterDeviceModeDestinationsForOptIn, (_options$updateCDNSet = options === null || options === void 0 ? void 0 : options.updateCDNSettings) !== null && _options$updateCDNSet !== void 0 ? _options$updateCDNSet : function (id) {
                  return id;
                }),
                disable: this.createDisableOption(initialCategories, options === null || options === void 0 ? void 0 : options.disable)
              })));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadWithFilteredDeviceModeDestinations() {
        return _loadWithFilteredDeviceModeDestinations.apply(this, arguments);
      }
      return loadWithFilteredDeviceModeDestinations;
    }()
    /**
     * The orignal analytics load function, but also stores the CDN settings on the instance.
     */
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;
      for (var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        _ref2[_key2] = arguments[_key2];
      }
      var settings = _ref2[0],
        options = _ref2[1];
      return this.ogAnalyticsLoad(settings, _objectSpread(_objectSpread({}, options), {}, {
        updateCDNSettings: pipe((options === null || options === void 0 ? void 0 : options.updateCDNSettings) || function (id) {
          return id;
        }, function (cdnSettings) {
          logger.debug('CDN settings loaded', cdnSettings);
          // extract the CDN settings from this call and store it on the instance.
          _this2.cdnSettingsDeferred.resolve(cdnSettings);
          return cdnSettings;
        })
      }));
    }
    /**
     * Replace the load fn with a new one
     */
  }, {
    key: "replaceLoadMethod",
    value: function replaceLoadMethod(loadFn) {
      this.analytics.load = loadFn;
    }
  }, {
    key: "page",
    value: function page() {
      this.analytics.page();
    }
  }, {
    key: "configureBlockingMiddlewareForOptOut",
    value: function configureBlockingMiddlewareForOptOut() {
      addBlockingMiddleware(this.cdnSettings, this.analytics, {
        integrationCategoryMappings: this.settings.integrationCategoryMappings,
        shouldEnableIntegration: this.settings.shouldEnableIntegration
      });
    }
  }, {
    key: "configureConsentStampingMiddleware",
    value: function configureConsentStampingMiddleware() {
      var _this3 = this;
      var pruneUnmappedCategories = this.settings.pruneUnmappedCategories;
      // normalize getCategories pruning is turned on or off
      var getCategoriesForConsentStamping = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var categories;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.getCategories();
              case 2:
                categories = _context4.sent;
                if (!pruneUnmappedCategories) {
                  _context4.next = 10;
                  break;
                }
                _context4.t0 = getPrunedCategories;
                _context4.t1 = categories;
                _context4.next = 8;
                return _this3.getAllCategories();
              case 8:
                _context4.t2 = _context4.sent;
                return _context4.abrupt("return", (0, _context4.t0)(_context4.t1, _context4.t2));
              case 10:
                return _context4.abrupt("return", categories);
              case 11:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function getCategoriesForConsentStamping() {
          return _ref3.apply(this, arguments);
        };
      }();
      var MW = createConsentStampingMiddleware(getCategoriesForConsentStamping);
      this.analytics.addSourceMiddleware(MW);
    }
    /**
     * Dispatch an event that looks like:
     * ```ts
     * {
     * "type": "track",
     *  "event": "Segment Consent Preference Updated",
     *  "context": {
     *    "consent": {
     *      "categoryPreferences" : {
     *         "C0001": true,
     *         "C0002": false,
     *    }
     *  }
     * ...
     * ```
     */
  }, {
    key: "consentChange",
    value: function consentChange(categories) {
      logger.debug('Consent change', categories);
      try {
        validateCategories(categories);
      } catch (e) {
        // not sure if there's a better way to handle this
        return console.error(e);
      }
      var CONSENT_CHANGED_EVENT = 'Segment Consent Preference Updated';
      this.analytics.track(CONSENT_CHANGED_EVENT, undefined, {
        consent: {
          categoryPreferences: categories
        }
      });
    }
  }]);
  return AnalyticsService;
}();
/**
 * Get possibly-initialized analytics.
 *
 * Reason:
 * There is a known bug for people who attempt to to wrap the library: the analytics reference does not get updated when the analytics.js library loads.
 * Thus, we need to proxy events to the global reference instead.
 *
 * There is a universal fix here: however, many users may not have updated it:
 * https://github.com/segmentio/snippet/commit/081faba8abab0b2c3ec840b685c4ff6d6cccf79c
 */
export var getInitializedAnalytics = function getInitializedAnalytics(analytics) {
  var isSnippetUser = Array.isArray(analytics);
  if (isSnippetUser) {
    var _analytics$_loadOptio, _opts$globalAnalytics;
    var opts = (_analytics$_loadOptio = analytics._loadOptions) !== null && _analytics$_loadOptio !== void 0 ? _analytics$_loadOptio : {};
    var globalAnalytics = window[(_opts$globalAnalytics = opts === null || opts === void 0 ? void 0 : opts.globalAnalyticsKey) !== null && _opts$globalAnalytics !== void 0 ? _opts$globalAnalytics : 'analytics'];
    // we could probably skip this check and always return globalAnalytics, since they _should_ be set to the same thing at this point
    // however, it is safer to keep buffering.
    if (globalAnalytics !== null && globalAnalytics !== void 0 && globalAnalytics.initialized) {
      return globalAnalytics;
    }
  }
  return analytics;
};